<template>
    <v-col
        xs="12"
        sm="6"
        md="5"
        lg="3"
    >
        <v-card elevation="7">
            <v-card-title
                class="primary white--text headline justify-center text-center flex-column"
            >
                <div
                    v-for="title in price.title.split('\n')"
                    :key="title.id"
                >
                    {{ title }}
                </div>
            </v-card-title>

            <p class="display-2 text-center primary white--text pb-8">
                <template v-if="price.is_trial">Trial</template>

                <template v-else-if="price.is_specific && price.price == 0">
                    Gratis
                </template>

                <template v-else>
                    Rp {{ formattedPrice }}

                    <span
                        v-if="tutoring"
                        class="title"
                    >
                        /orang
                    </span>
                </template>
            </p>

            <v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="$emit('register')"
                        block
                        x-large
                        color="primary"
                    >
                        Daftar sekarang
                    </v-btn>
                </v-card-actions>
                <v-list dense>
                    <v-list-item
                        v-for="(description, i) in descriptions"
                        :key="i"
                    >
                        {{ description }}
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import priceFormat from '@/tools/priceFormat'
export default {
    props: {
        price: {
            type: Object,
            required: true,
        },

        tutoring: {
            type: Boolean,
        },
    },

    computed: {
        formattedPrice() {
            return priceFormat(this.price.price)
        },

        descriptions() {
            return this.price.description
                ? this.price.description.split('\n')
                : ''
        },
    },
}
</script>
